import { Mappable, Mapped } from '../../rest/decorators/mapped'
import {
  mapMorphable,
  Morphable,
  morphableName,
} from '../../rest/utilities/morphable'
import { RestQuery } from '../../rest/utilities/rest-query'
import { HardwareRegistrationStatusResponse } from '../seeders/hardware-registration-status'
import { HardwareRegistrationStatus } from './hardware-registration-status'

@Mapped(
  {
    internal_id: { property: 'internalID' },
  },
  ['numericID']
)
class RegistrationJob extends Mappable {
  id!: string | number
  numericID!: number
  ulid!: string
  internalID!: string

  static create<Data>(attrs: Data) {
    return new RegistrationJob().map(attrs)
  }
}

@Mapped(
  {
    status: { format: HardwareRegistrationStatus.create },
    job: { format: RegistrationJob.create },
    device_number: { property: 'deviceNumber' },
    createdBy: { format: mapMorphable },
    created_by: { format: mapMorphable, property: 'createdBy' },
    registered_at: { property: 'registered', type: 'date' },
    registeredBy: { format: mapMorphable },
    registered_by: { format: mapMorphable, property: 'registeredBy' },
  },
  ['numericID', 'timestamps']
)
export class HardwareRegistration extends Mappable {
  id!: string | number
  numericID!: number
  ulid!: string
  status!: HardwareRegistrationStatusResponse
  job?: RegistrationJob
  deviceNumber!: string | null
  createdBy?: Morphable
  registered!: Date | null
  registeredBy?: Morphable
  created!: Date
  updated!: Date
  deleted!: boolean

  static create<Data>(attrs: Data) {
    return new HardwareRegistration().map(attrs)
  }

  get createdByName(): string {
    return morphableName(this.createdBy)
  }

  get registeredByName(): string {
    return morphableName(this.registeredBy)
  }
}

interface Filters {
  keywords?: string
  status?: string
}
type Ordering = 'created_at' | '-created_at'
type Includes =
  'job' | 'job.customer' | 'job.endUser' | 'createdBy' | 'registeredBy'

export class HardwareRegistrationQuery extends RestQuery<
  Filters,
  Ordering,
  Includes
> {}
